// extracted by mini-css-extract-plugin
module.exports = {"container":"_90d09d70","question":"_1792fc99","questiontitle":"_5e980fa6","answer":"_03de5a27","toggleicon":"ce87b41e"};